import { render, staticRenderFns } from "./riskeylemplani.vue?vue&type=template&id=a41cccee"
import script from "./riskeylemplani.vue?vue&type=script&lang=js"
export * from "./riskeylemplani.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports